var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconeLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5714 0H3.41786C1.53214 0 0 1.55357 0 3.46071V44.5393C0 46.4464 1.53214 48 3.41786 48H44.5714C46.4571 48 48 46.4464 48 44.5393V3.46071C48 1.55357 46.4571 0 44.5714 0ZM14.5071 41.1429H7.39286V18.2357H14.5179V41.1429H14.5071ZM10.95 15.1071C8.66786 15.1071 6.825 13.2536 6.825 10.9821C6.825 8.71071 8.66786 6.85714 10.95 6.85714C13.2214 6.85714 15.075 8.71071 15.075 10.9821C15.075 13.2643 13.2321 15.1071 10.95 15.1071ZM41.175 41.1429H34.0607V30C34.0607 27.3429 34.0071 23.925 30.3643 23.925C26.6571 23.925 26.0893 26.8179 26.0893 29.8071V41.1429H18.975V18.2357H25.8V21.3643H25.8964C26.85 19.5643 29.175 17.6679 32.6357 17.6679C39.8357 17.6679 41.175 22.4143 41.175 28.5857V41.1429Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeLinkedin);
export default __webpack_public_path__ + "static/media/icone-linkedin.efea089f0b3ba66ed79eea2b321ba34a.svg";
export { ForwardRef as ReactComponent };